import Tooltip from "../../../../components/tooltip";
import SimulationSurplusCreation from "./SurplusCreation/ppeConsoleTable";
import SimulationScenarioComparison from "./ScenarioComparison/ppeConsoleTable";
import SurplusDeficitAnalysis from "./SurplusCreation/SimulationDeficit";
import SimulationHeader from "../utility/SimulationHeader";
import { useState } from "react";
import { useOptimizerNavigation } from "../utility/useOptimizerNavigation";
import MainHeader from "../utility/DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import DateRangeSelector from "../DateRange/DateRangeSelector";
import { useSelector } from "react-redux";
import Loading from "../../../../components/Loading";
import ToggleTabs from "../utility/ChartTableToggle";
import SimulationSurplusCreationSummaryAnalysis from "./SurplusCreation/SimulationVolumeChart";
import AnnualSummarySurplusCreationTable from "./SurplusCreation/SimulationTable";
import { Edit } from "lucide-react";
import Modal from "./SurplusCreation/Modal";
import { DeficitBidTable } from "./SurplusCreation/VcEdit";
import SimulationSurplusCreationAnalysis from "./SurplusCreation/SimulationCostChart";
import { postBessGeneratorChargesChange } from "../../../../Rest_api/RestApi";
import SimulationSurplusCreationSummaryChart from "./SurplusCreation/SimulationSummaryChart";
import ScenarioComparisonAnylysis from "./ScenarioComparison/ScenarioCapacity/GnaUtilisation";
import ScenarioComparisonCostAnylysis from "./ScenarioComparison/ScenarioCost/GnaUtilisation";
import LoadGenerationContributor from "./SurplusCreation/LoadGenerationContributor";
import SurplusDeficitContributor from "./SurplusCreation/SurplusDeficitContributor";
import SummaryContributor from "./SurplusCreation/SummaryContributor";
const DataTabs = ["Demand-Supply", "Surplus/Deficit", "Annual Summary"];
const MainTabs = ["Surplus-Creation", "Scenario Comparison"];
const ScenarioTabs = ["Capacity", "Cost"];

export default function RuvnlSimulationIndex() {
  const { navigateToPage } = useOptimizerNavigation();
  const [activeMainTab, setActiveMainTab] = useState(MainTabs[0]);
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(DataTabs[0]);
  const [activeScenarioTab, setActiveScenarioTab] = useState(ScenarioTabs[0]);
  const [bidData, setBidData] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [activeScenario, setActiveScenario] = useState<number>(0);  // For Surplus-Creation tab (single scenario)
  const [selectedScenarios, setSelectedScenarios] = useState<Array<{ scenario_id: number, scenario_number: number }>>([]); // For Scenario Comparison tab (multiple scenarios)

  const preSelectedstartDate = useSelector(
    (state: any) => state.SurplusOptimizerHPPCDate.startDate
  );
  const preSelectedendDate = useSelector(
    (state: any) => state.SurplusOptimizerHPPCDate.endDate
  );
  const [selectedTargetDate, setSelectedTargetDate] = useState<
    Array<{ value: string; label: string; isFixed: boolean }>
  >([]);
  const handleDateChange = (
    start: Date | null,
    end: Date | null,
    allDates: Array<{ value: string; label: string; isFixed: boolean }>
  ) => {
    setSelectedTargetDate(allDates);
  };

  // Handler for Scenario Comparison tab to receive selected scenario IDs
  const handleScenarioComparisonApply = (data: any) => {
    setSelectedScenarios(data.selectedScenarios || []);
    setRefreshKey((prev: any) => prev + 1);
  };

  async function handleUpdateReview(data: any) {
    try {
      setSubmitLoading(true);
      const response = await postBessGeneratorChargesChange(data);
      if (response) { setRefreshKey((prev: any) => prev + 1); }

      if (response) { setRefreshKey((prev: any) => prev + 1); }

      setModalOpen(false);
      // setModalFilter(false);
    } catch (error) {
      setError("Failed to update Deficit data");
      console.error("Error updating Deficit data:", error);
    } finally {
      setSubmitLoading(false);
    }
  }
  return (
    <>
      <div className="w-full overflow-hidden">
        {loading && <Loading />}
        <MainHeader />
        <div className="tabContent">
        <div className="h-[calc(-85px+100vh)] p-4 overflow-hidden">
          <div className="w-full h-full flex flex-col gap-4 overflow-hidden">
            <SimulationHeader
              title={"Surplus Deficit"}
              activeTab={activeMainTab}
              setActiveTab={setActiveMainTab}
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
            />
            {activeMainTab === "Surplus-Creation" && (
              <div className="flex flex-row gap-4 relative flex-1 min-h-0 overflow-hidden">
                <SimulationSurplusCreation
                  open={open}
                  setOpen={setOpen}
                  setError={setError}
                  refreshKey={refreshKey}
                  setRefreshKey={setRefreshKey}
                  onActiveScenarioChange={setActiveScenario}
                />

                <div
                  className="gas-chart-container !p-0 bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl flex flex-col min-w-0"
                  style={{
                    height: "100%",
                    flex: 1,
                    overflow: "hidden",
                  }}
                >

                  <div className="flex flex-col h-full w-full min-w-0 overflow-hidden">
                    {/* Header with Date Range and Tabs - Fixed height */}
                    <div className="flex justify-between items-center border-b border-[#DFEAF2] p-2 flex-shrink-0 min-w-0">
                      <div className="flex items-center gap-3 min-w-0">
                        {activeTab !== "Annual Summary" && (
                          <DateRangeSelector
                            placeholder="Select Date Range"
                            startDate={preSelectedstartDate}
                            endDate={preSelectedendDate}
                            onDateChange={handleDateChange}
                          />
                        )}
                      </div>
                      <div className="flex gap-x-6 justify-end flex-shrink-0">
                        <button
                          onClick={() => setModalOpen(true)}
                          className="flex items-center gap-2 p-2 text-xs rounded-xl border font-medium transition-colors border-[#34656D] bg-[#EFFCFF] text-[#34656D]"
                        >
                          <div />
                          Generator Details
                        </button>
                        <ToggleTabs
                          tabs={DataTabs}
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                        />
                      </div>
                    </div>

                    {/* Content area - Takes remaining height */}
                    <div className="load-data grid grid-cols-2 p-2 md:grid-cols-12 grid-rows-full md:grid-rows-[60%_40%] gap-2 h-full w-full md:overflow-hidden rounded-2xl bg-[#F8F9FA]">
                      {activeTab === "Demand-Supply" &&
                        <SimulationSurplusCreationSummaryAnalysis
                          selectedBlock={selectedBlock}
                          refreshKey={refreshKey}
                          setError={setError}
                          setUniqueTargetDate={setUniqueTargetDate}
                          selectedTargetDate={selectedTargetDate}
                        />}

                      {activeTab === "Surplus/Deficit" &&
                        <SimulationSurplusCreationAnalysis
                          selectedBlock={selectedBlock}
                          refreshKey={refreshKey}
                          setError={setError}
                          setUniqueTargetDate={setUniqueTargetDate}
                          selectedTargetDate={selectedTargetDate}
                        />}

                      {activeTab === "Annual Summary" && (
                        <AnnualSummarySurplusCreationTable
                          refreshKey={refreshKey}
                          setError={setError}
                        />
                      )}

                      {activeTab === "Demand-Supply" && (
                        <LoadGenerationContributor
                          refreshKey={refreshKey}
                          selectedBlock={selectedBlock}
                          startDate={preSelectedstartDate}
                          endDate={preSelectedendDate}
                          scenarioId={activeScenario}
                          setError={setError}
                        />
                      )}

                      {activeTab === "Surplus/Deficit" && (
                        <SurplusDeficitContributor
                          refreshKey={refreshKey}
                          selectedBlock={selectedBlock}
                          startDate={preSelectedstartDate}
                          endDate={preSelectedendDate}
                          scenarioId={activeScenario}
                          setError={setError}
                        />
                      )}

                      {activeTab === "Annual Summary" && (
                        <SummaryContributor
                          refreshKey={refreshKey}
                          selectedBlock={selectedBlock}
                          startDate={preSelectedstartDate}
                          endDate={preSelectedendDate}
                          scenarioId={activeScenario}
                          setError={setError}
                        />
                      )}
                    </div>
                  </div>


                  {/* {activeMainTab === "Optimal" && <RuvnlOptimalIndex />}
                {activeMainTab === "Metrics" && <MetricsProcurement />} */}
                </div>
              </div>
            )}

            {activeMainTab === "Scenario Comparison" && (
              <div className="flex flex-row gap-4 relative flex-1 min-h-0 overflow-hidden">
                <SimulationScenarioComparison
                  open={open}
                  setOpen={setOpen}
                  setError={setError}
                  refreshKey={refreshKey}
                  setRefreshKey={setRefreshKey}
                  onScenarioComparisonApply={handleScenarioComparisonApply}
                  selectedScenarios={selectedScenarios}
                />

                <div
                  className="gas-chart-container bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl flex flex-col min-w-0 !p-0"
                  style={{
                    height: "100%",
                    flex: 1,
                    overflow: "hidden",
                  }}
                >

                  <div className="flex flex-col h-full w-full min-w-0 overflow-hidden">
                    {/* Header with Date Range and Tabs - Fixed height */}
                    <div className="flex justify-between items-center border-b border-[#DFEAF2] !p-2 flex-shrink-0 min-w-0 ">
                      <div className="flex items-center gap-3 min-w-0">
                        <h2 className="chartHeading !text-sm w-60">Metrics</h2>
                      </div>
                      <div className="flex gap-x-6 justify-end flex-shrink-0">
                        <ToggleTabs
                          tabs={ScenarioTabs}
                          activeTab={activeScenarioTab}
                          setActiveTab={setActiveScenarioTab}
                        />
                      </div>
                    </div>
                    
                    {activeScenarioTab === "Capacity" &&
                      <ScenarioComparisonAnylysis
                        selectedBlock={selectedBlock}
                        refreshKey={refreshKey}
                        setError={setError}
                        setUniqueTargetDate={setUniqueTargetDate}
                        selectedTargetDate={selectedTargetDate}
                        selectedScenarios={selectedScenarios}
                      />}
                    {activeScenarioTab === "Cost" &&
                      <ScenarioComparisonCostAnylysis
                        selectedBlock={selectedBlock}
                        refreshKey={refreshKey}
                        setError={setError}
                        setUniqueTargetDate={setUniqueTargetDate}
                        selectedTargetDate={selectedTargetDate}
                        selectedScenarios={selectedScenarios}
                      />}

                  </div>
                </div>
              </div>
            )}
          </div>

        </div>

        <ErrorPopup error={error} onClose={() => setError(null)} />
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5">
            <Tooltip
              note={
                <p>
                  {/* Default values and variable charges are auto-fetched from
                  system. */}
                </p>
              }
              text=""
            >
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
        </div>
        <Modal isOpen={isModalOpen} onClose={() => setModalOpen(true)}>
          <div className="w-full">
            <div className="h-[calc(-73px+100vh)]">
              <div className="w-full h-full flex flex-col gap-4">
                <div
                  className="gas-chart-container"
                  style={{
                    height: "calc(-60px + 100vh)",
                    borderRadius: "0px!important",
                  }}
                >
                  <div className="gas-heading gap-x-10 text-center">
                    <h2 className="chartHeading !text-base !font-medium w-full">
                      Generator Details
                    </h2>
                  </div>
                  <DeficitBidTable
                    // setModalFilter={setModalFilter}
                    handleUpdateReview={handleUpdateReview}
                    loading={submitLoading}
                    setModalOpen={setModalOpen}
                    mode={"edit"}
                    handleSubmit={handleUpdateReview}
                    maxHeight="calc(-60px + 100vh)"
                    refreshKey={refreshKey}
                    setRefreshKey={setRefreshKey}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
